<sd-modal>
  <div class="wrapper">
    <h4>Схема склада</h4>
    <div class="img-wrapper">
      <img *ngIf="scheme" class="img" alt="schemeImg" src="{{ scheme | sdUrlMedia }}" />
    </div>
  </div>
</sd-modal>
